// extracted by mini-css-extract-plugin
module.exports = {"loader":"CircularProgress_loader__MJSfM","spin":"CircularProgress_spin__GMsRJ","track":"CircularProgress_track__cuJk2","progress":"CircularProgress_progress__3gNjB"};